





































import { Component, Prop, Vue } from 'vue-property-decorator';
import Button from '../../core/components/Button.vue';
import SimpleLink from '../../core/components/SimpleLink.vue';
import InfoIcon from '../../core/components/InfoIcon.vue';
import { OptionBtnWithMenu } from '../models/util-models';

@Component({
  components: {
    Button,
    InfoIcon,
    SimpleLink
  }
})
export default class BtnMenuWithOptions extends Vue {
  @Prop({ default: '' }) activatorId!: string;
  @Prop({ default: 'activator' }) activatorLabel!: string;
  @Prop({ default() {return []} }) menuItems: OptionBtnWithMenu[];
  @Prop({ default: '' }) iconButton: string;
  @Prop({ default: 'success' }) buttonColor: string;


  get activatorSelector(): string {
    return `#${this.activatorId}`;
  }
}

